<script setup lang="ts">
import { inject, Ref } from 'vue';
import Button from 'primevue/button';

const dialogRef = inject('dialogRef') as Ref;
const onSave = dialogRef.value.options.emits.onSave;
const title = dialogRef?.value?.data?.title;
const description = dialogRef?.value?.data?.description;
const isAlignCenter = dialogRef?.value?.data?.isAlignCenter;

const selectNo = () => {
  dialogRef.value.close();
};

const selectYes = () => {
  onSave?.();
  selectNo();
};
</script>
<template>
  <div>
    <div :class="['header', { 'text-center': isAlignCenter }]">
      <p class="text-lg text-start">{{ title }}</p>
      <p class="text-lg text-start">{{ description }}</p>
    </div>
    <div class="flex justify-content-between gap-3">
      <Button :label="$t('common.buttons.confirm')" @click="selectYes()"></Button>
      <Button :label="$t('common.buttons.cancel')" @click="selectNo()"></Button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
:deep() {
  .p-dialog-header {
    margin-left: 100%;
    background-color: #ccc;
  }
}
</style>
